import { render } from "./GroupLeaderDashboard.vue?vue&type=template&id=735a3e3f"
import script from "./GroupLeaderDashboard.vue?vue&type=script&lang=js"
export * from "./GroupLeaderDashboard.vue?vue&type=script&lang=js"

import "./GroupLeaderDashboard.vue?vue&type=style&index=0&id=735a3e3f&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__